import React,{useState,useEffect} from 'react';
import axios from 'axios';
import TopCouponsHead from './Components/TopCoupons/TopCouponsHead';
import TopCouponsTitle from './Components/TopCoupons/TopCouponsTitle';
import ImagesCoupons from './Components/Coupons/ImagesCoupons';
import styled from 'styled-components';
import SeasonalOffers from './Components/SeasonalOffers/SeasonalOffers';
import TopCouponsCoupons from './Components/TopCoupons/TopCouponsCoupons';

const TopCoupons = () => {
  const [images,setImages]= useState([])
  
  useEffect(()=>{
    axios.get('https://api.bakpoket.com/api/Cat_TC_BO/get-Cat_TC_BO?position=TC')
    .then(res=>setImages(res.data))
    .catch(err=>console.log(err))
  })

  return (
    <Wrapper>
      <TopCouponsHead />
      <TopCouponsTitle />
      {/* <ImagesCoupons/> */}
      <TopCouponsCoupons/>
      <div className="image-container text-center">
        {images && (
          <a
          href={`https://${images.merchantURL}`}
          target="_blank"
          rel="noopener noreferrer"
          >
          <img
          className="topcoupons-ad"
          src={`data:image/png;base64,${images.base64}`}
          alt="Top Coupons AD"
          />
          </a>
        )} 
      </div>
      {/* <TopCouponsoffers /> */}
      <SeasonalOffers/>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .image-container {
    display: flex;
    justify-content: center;
    margin: 20px auto;
  }

  .topcoupons-ad {
    width: 100%;
    max-width: 1080px;
  }

  @media (max-width: 480px) {
    .topcoupons-ad {
      width: 90%;
    }
  }
`;

export default TopCoupons;
